module.exports = __webpack_public_path__ + "static/media/logoDark.8e8a7613.png";